import { IComplateRequest } from '../../../interfaces'
import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import moment from 'jalali-moment';

const request_endpoints = APIS_ENDPOINTS.request

export const request_getAllByUser = async ({
  search,
  CurrentPage,
  PageSize,
  userId,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  userId: string
}) => {
  return http.get(
    request_endpoints.getallrequestbyuserid +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}&UserId=${userId}${
        search ? `&search=${search}` : ''
      }${userId ? `&UserId=${userId}` : ''}`
  )
}

export const request_rejectrequest = async ({
  id,
  text,
  otherFilesInputRef,
}: {
  id: number
  text: string
  otherFilesInputRef: any[]
}) => {
  const formData = new FormData()
  formData.append('Id', id.toString())
  formData.append('Text', text)
  const files = otherFilesInputRef ?? []
  for (let i = 0; i < files.length; i++) {
    formData.append('IFile', files[i])
  }
  return http.post(request_endpoints.rejectrequest, formData)
}

export const request_getrequeststoppageperroleasync = async () => {
  return http.get(request_endpoints.getrequeststoppageperroleasync)
}

export const request_getrequestcountbyadminrole = async () => {
  return http.get(request_endpoints.getrequestcountbyadminrole)
}

export const request_exportrequeststoppageperroleasync = async () => {
  return http.get(request_endpoints.exportrequeststoppageperroleasync)
}

export const request_exportrequestcountbyadminrole = async () => {
  return http.get(request_endpoints.exportrequestcountbyadminrole)
}

export const request_imscompleterequest = async ({ data, id }: { data: IComplateRequest, id: number }) => {
  const payload = {
    Id: id,
    Date: moment(data.contractConclusionDate).format("YYYY-MM-DDTHH:mm:ss.SSSSSSS"),
    Time: data.time || "",
    IsGratuitously: data.isGratuitously,
    ContractAmount: data.contractAmount ? Number(data.contractAmount) : 0,
    FacilityRate: data.facilityRate ?? 0,
    FacilitiesBenefitAmount: data.facilitiesBenefitAmount ? Number(data.facilitiesBenefitAmount) : 0,
    PlanName: data.planName || "",
    PlanProvince: data.planProvince ?? null,
    PlanDomain: data.planDomain ?? null,
    PartnershipStatus: data.partnershipStatus ?? null,
    ServiceType: data.serviceType ?? null,
    ServiceTypeDescription: data.serviceTypeDescription || "",
    FacilityContractType: data.facilityContractType ?? null,
    FacilityContractTypeDescription: data.facilityContractTypeDescription || "",
    PaymentPeriod: data.paymentPeriod ?? null,
    PaymentSteps: data.paymentSteps ?? null,
    BreathingPeriod: data.breathingPeriod ?? null,
    RepaymentPeriod: data.repaymentPeriod ?? null,
    RepaymentSteps: data.repaymentSteps ?? null,
    InstallmentsInterval: data.installmentsInterval ?? null,
    LoanDepositAmount: data.loanDepositAmount ? Number(data.loanDepositAmount) : null,
    HaveSecurity: data.haveSecurity,
    Applicants: data.applicants ?? [],
    RepaymentsPaybacks: data.repaymentsPaybacks ?? [],
    Resources: (data.resources && data?.resources?.length > 0)
      ? data.resources?.map(i => ({
        ...i,
        rialWorth: i.rialWorth ? Number(i.rialWorth) : 0
      }))
      : [],
    ContractSecurities: (data.contractSecurities && data?.contractSecurities?.length > 0)
      ? data.contractSecurities?.map(i => ({
        ...i,
        securityCost: i.securityCost ? Number(i.securityCost) : 0,
      }))
      : [],
    paymentspaies: (data.paymentspaies && data?.paymentspaies?.length > 0)
      ? data.paymentspaies?.map(i => ({
        ...i,
        amountPaidToCompany: i.amountPaidToCompany ? Number(i.amountPaidToCompany) : 0,
      }))
      : [],
    Deposits: (data.deposits && data?.deposits?.length > 0)
      ? data.deposits?.map(i => ({
        ...i,
        amountConvertedIntoFree: i.amountConvertedIntoFree ? Number(i.amountConvertedIntoFree) : 0,
        receiptAmountAll: i.receiptAmountAll ? Number(i.receiptAmountAll) : 0,
        lateFreeAmount: i.lateFreeAmount ? Number(i.lateFreeAmount) : 0,
      }))
      : [],
  };

  return http.put(request_endpoints.imscompleterequest, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
